import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TipoConteudo } from 'src/app/model/arquivo.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { RecuperacaoCreditoService } from '../recuperacao-credito/recuperacao-credito.service';



@Component({
    selector: 'app-recuperacao-credito-lote-envio',
    templateUrl: './recuperacao-credito-lote-envio.component.html',
    standalone: false
})
export class RecuperacaoCreditoLoteEnvioComponent implements OnInit {

  titulo = 'Envio de recuperações de crédito';
  instrucoesEnvio = 'Envie um arquivo com suas recuperações de crédito.';
  tipoConteudoArquivo = TipoConteudo.RECUPERACOES_CREDITO;
  textoBtnArquivoExemplo = "Exemplo de Recuperações de Crédito";
  tipoArquivoExemplo = "Recuperação de Crédito";

  constructor(protected injector: Injector,
    protected service: RecuperacaoCreditoService,
    private permissaoService: PermissaoService,
    private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
  }
}
